import React, { useEffect, useState } from "react";
import { faPencil, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, CardBody, CardHeader, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import DataTable from "datatables.net-react";
import DT from "datatables.net-bs5";
import "datatables.net-responsive-dt";
import { useApiStore } from "../../hooks/ApiStoreContext";
import Swal from "sweetalert2";

function Category() {
  const apiStore = useApiStore();
  DataTable.use(DT);
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    getCategoryList();
  }, []);

  const getCategoryList = async () => {
    try {
      const response = await apiStore.get("/categories");
      setTableData(response);
    } catch (error) {
      if (error.response.status !== 401) {
        console.error("There was an error fetching categories!", error);
      }
    }
  };

  const handleAdd = (e) => {
    e.preventDefault();
    navigate("/add-category");
  };

  const handleEdit = (e, id) => {
    e.preventDefault();
    navigate("/add-category/" + id);
  };

  const handleDelete = async (e, id) => {
    e.preventDefault();

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        await apiStore.delete(`/categories/${id}`);
        await Swal.fire("Deleted!", "Category deleted successfully.", "success");
        getCategoryList();
      } catch (error) {
        if (error.response.status !== 401) {
          console.error("There was an error deleting the category!", error);
          if (error.response && error.response.status == 409 && error.response.data) {
            Swal.fire("Error!", error.response.data, "error");
          } else {
            Swal.fire("Error!", "There was an error deleting the category.", "error");
          }
        }
      }
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      Swal.fire("Cancelled", "Your category is safe :)", "error");
    }
  };

  const handleStatus = async (e, data, row) => {
    try {
      const submitData = {
        categoryId: row.categoryId,
        name: row.name,
        link: row.link,
        description: row.description,
        imageSource: row.imageSource,
        parentCategoryId: row.parentCategoryId,
        isActive: !data,
      };
      await apiStore.put(`/categories/${row.categoryId}`, submitData);
      getCategoryList();
    } catch (error) {
      if (error.response.status !== 401) {
        console.error("There was an error updating the category status!", error);
      }
    }
  };

  return (
    <Row>
      <Col md={12}>
        <Card className="mb-4">
          <CardHeader className="pb-0">
            <Row>
              <Col md={9}>
                <h4>Category List</h4>
              </Col>
              <Col md={3} className="d-grid d-md-flex justify-content-md-end d-sm-block">
                <Button variant="outline-primary" className="btn-sm" onClick={handleAdd}>
                  Add Category
                </Button>
              </Col>
            </Row>
          </CardHeader>
          <CardBody className="px-0 pt-0 pb-2">
            <div className="mx-3">
              <DataTable
                className="display table align-items-center mb-0 p-0"
                data={tableData}
                options={{
                  responsive: true,
                  columns: [
                    { data: "name", className: "text-secondary text-sm font-weight-bold align-middle" },
                    { data: "link", className: "text-secondary text-sm font-weight-bold align-middle" },
                    { data: "description", className: "text-secondary text-sm font-weight-bold align-middle" },
                    { data: "imageSource", className: "text-secondary text-sm font-weight-bold align-middle", visible: false },
                    { data: "parentCategoryName", className: "text-secondary text-sm font-weight-bold align-middle" },
                    { data: "isActive", className: "text-sm font-weight-bold align-middle text-center" },
                    { data: "categoryId", className: "text-secondary text-sm font-weight-bold align-middle text-center" },
                  ],
                }}
                slots={{
                  5: (data, row) => {
                    return (
                      <React.Fragment>
                        <span className={data ? "badge badge-sm cursor-pointer bg-gradient-success" : "badge badge-sm cursor-pointer bg-gradient-danger"} onClick={(e) => handleStatus(e, data, row)}>
                          {data ? "Active" : "Inactive"}
                        </span>
                      </React.Fragment>
                    );
                  },
                  6: (data, row) => {
                    return (
                      <React.Fragment>
                        <a className="me-3 cursor-pointer" title="Edit" onClick={(e) => handleEdit(e, data)}>
                          <FontAwesomeIcon icon={faPencil} size="lg"></FontAwesomeIcon>
                        </a>
                        <a className="text-danger cursor-pointer" title="Delete" onClick={(e) => handleDelete(e, data)}>
                          <FontAwesomeIcon icon={faTrashCan} size="lg"></FontAwesomeIcon>
                        </a>
                      </React.Fragment>
                    );
                  },
                }}>
                <thead>
                  <tr>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Name</th>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Link</th>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Description</th>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Image Source</th>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Parent Category</th>
                    <th className="text-center text-uppercase text-secondary text-sm font-weight-bolder">Status</th>
                    <th className="text-center text-uppercase text-secondary text-sm font-weight-bolder">Action</th>
                  </tr>
                </thead>
              </DataTable>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}

export default Category;
